import { APP_BASE_HREF, Location } from '@angular/common';
import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { AppService } from '@app/_core/services/app.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { SecurityService } from '@app/_core/services/security.service';
import { AssignAgentsComponent } from '@app/pages/common/assign-agents/assign-agents.component';
import { ConfirmDialogComponent } from '@app/pages/common/confirm-dialog/confirm-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ConfirmationService, MessageService } from 'primeng/api';
import { catchError, EMPTY, lastValueFrom, map } from 'rxjs';

@Component({
  selector: 'app-queue-details',
  templateUrl: './queue-details.component.html',
  styleUrls: ['./queue-details.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  providers: [ConfirmationService, MessageService],
})
export class QueueDetailsComponent implements OnInit {
  @ViewChild(AssignAgentsComponent)
  private assignAgentComponent!: AssignAgentsComponent;

  queueData = null;
  assignmentController;
  alertModal = null;
  queueID = null;
  nameText;
  typeText;
  lengthText;
  phoneNumberText;
  createdText;
  lastUpdatedText;
  outboundStopCheck;
  daysGroup;

  startTime;
  endTime;
  timezone;
  testingCheck: boolean = false;
  emergencyCheck: boolean = false;
  emergencyBypassIVRCheck;
  emergencyMessageText;
  emergencyPromptID;
  afterHoursPromptID;
  lastMessageType;
  defaultEmergencyMessage;
  customEmergencyMessage;
  afterHoursEmergencyMessage;
  slaContainer;
  slaPreScheduleText;
  slaPostScheduleText;
  allowEarlyFollowUpsCheck;
  previewBtn;
  showAvailabilityContainer: boolean = false;
  showCallbackContainer: boolean = false;
  //callbackByQueueLength;
  //callbackByWaitTime;
  queueLengthMax;
  waitTimeMax;
  dataLoaded = false;
  pendingData = null;

  timezones: any = [];
  timezoneSelect: any;

  isCampaign: boolean = false;
  hideLabel: boolean = false;
  hideFileName: boolean = true;
  msglabel = 'Add Audio File to Message:';

  emergencyMessageType: any = [];
  selectedEmergencyMessageType;
  callBackByQueueLengthCheck: boolean = false;

  callBackByWaitTimeCheck: boolean = false;
  queueType;

  sunday;
  monday;
  tuesday;
  wednesday;
  thursday;
  friday;
  saturday;

  modalRef?: BsModalRef;

  currentpath: any = {};

  //queueDetail: any;
  details: any;
  title: string = '';
  constructor(
    private appService: AppService,
    private route: ActivatedRoute,
    private router: Router,
    private managerService: ManagerService,
    private securityService: SecurityService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private modalService: BsModalService,
    private location: Location,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {}
  async ngOnInit(): Promise<void> {
    await this.loadTimeZones();
    this.route.params.subscribe((params: any) => {
     // console.log(params);
      //  alert(params.id)
      this.loadQueueDetails(params.id);
      // this.loadQueueAgents(params.id)
    });

    const urlArray: any = this.router.url.split('/');
    urlArray.shift();
    if (urlArray.length > 0) {
      for (let i = 0; i < urlArray.length - 1; i++) {
        this.currentpath += urlArray[i] + (urlArray[i + 2] ? '>' : '');
      }
    }
  }

  modifyTestingCheck($event) {
    const isChecked = $event.target.checked;
    $event.target.checked = false;
    if (isChecked) {
      const initialState = {
        title: 'Are you sure?',
        contentMsg:
          'This will put this queue into testing mode and will not be visible to users without the Testing, TMTesting or Admin grants.',
        confirmBtnValue: 'Ok',
        cancelBtnValue: 'Cancel',
      };

      const config: ModalOptions = {
        class: 'confirm-dialog modal-dialog-centered modal-wd-290',
        initialState,
      };

      this.modalRef = this.modalService.show(ConfirmDialogComponent, config);

      this.modalRef.content.event.subscribe((result: any) => {
        if (result.value == 'confirm') {
          this.testingCheck = true;
          $event.target.checked = true;
        } else {
          this.testingCheck = false;
          $event.target.checked = false;
        }
        this.modalRef.hide();
      });
    } else {
      this.testingCheck = false;
    }
  }

  modifyEmergencyCheck($event) {
    const isChecked = $event.target.checked;
    $event.target.checked = false;
    if (isChecked) {
      const initialState = {
        title: 'Are you sure?',
        contentMsg: 'This will enable emergency within the IVR flow.',
        confirmBtnValue: 'Ok',
        cancelBtnValue: 'Cancel',
      };

      const config: ModalOptions = {
        class: 'confirm-dialog modal-dialog-centered modal-wd-290',
        initialState,
      };

      this.modalRef = this.modalService.show(ConfirmDialogComponent, config);

      this.modalRef.content.event.subscribe((result: any) => {
        if (result.value == 'confirm') {
          this.emergencyCheck = true;
          $event.target.checked = true;
        } else {
          this.emergencyCheck = false;
          $event.target.checked = false;
        }
        this.modalRef.hide();
      });
    } else {
      this.emergencyCheck = false;
    }
  }

  modifyCallBackByQueueLengthCheck($event) {
    const isChecked = $event.target.checked;
    $event.target.checked = false;
    if (isChecked) {
      this.callBackByQueueLengthCheck = true;
      $event.target.checked = true;
    } else {
      this.callBackByQueueLengthCheck = false;
      $event.target.checked = false;
    }
  }

  modifyEmergencyBypassIVRCheck($event) {
    const isChecked = $event.target.checked;
    $event.target.checked = false;
    if (isChecked) {
      const initialState = {
        title: 'Are you sure?',
        contentMsg: 'This will answer all calls for this queue with an immediate emergency message.',
        confirmBtnValue: 'Ok',
        cancelBtnValue: 'Cancel',
      };

      const config: ModalOptions = {
        class: 'confirm-dialog modal-dialog-centered modal-wd-290',
        initialState,
      };

      this.modalRef = this.modalService.show(ConfirmDialogComponent, config);

      this.modalRef.content.event.subscribe((result: any) => {
        if (result.value == 'confirm') {
          this.emergencyBypassIVRCheck = true;
          $event.target.checked = true;
        } else {
          this.emergencyBypassIVRCheck = false;
          $event.target.checked = false;
        }
        this.modalRef.hide();
      });
    } else {
      this.emergencyBypassIVRCheck = false;
      $event.target.checked = false;
    }
  }

  modifyCallBackByWaitTimeCheck($event) {
    const isChecked = $event.target.checked;
    $event.target.checked = false;
    if (isChecked) {
      this.callBackByWaitTimeCheck = true;
      $event.target.checked = true;
    } else {
      this.callBackByWaitTimeCheck = false;
      $event.target.checked = false;
    }
  }
  modifyAvailableDayCheck($event, day) {
    const isChecked = $event.target.checked;
    $event.target.checked = false;
    switch (day) {
      case 'sunday':
        this.sunday = isChecked;
        break;

      case 'monday':
        this.monday = isChecked;
        break;

      case 'tuesday':
        this.tuesday = isChecked;
        break;
      case 'wednesday':
        this.wednesday = isChecked;
        break;
      case 'thursday':
        this.thursday = isChecked;
        break;
      case 'friday':
        this.friday = isChecked;

        break;
      case 'saturday':
        this.saturday = isChecked;

        break;
    }
    $event.target.checked = isChecked;
  }

  modifyEarlyAppointmentsCheck($event) {
    const isChecked = $event.target.checked;
    $event.target.checked = false;
    if (isChecked) {
      this.allowEarlyFollowUpsCheck = true;
      $event.target.checked = true;
    } else {
      this.allowEarlyFollowUpsCheck = false;
      $event.target.checked = false;
    }
  }
  setEmergencyMessage() {
    let message;
    this.defaultEmergencyMessage = this.parsePromptMessage(this.defaultEmergencyMessage);
    this.afterHoursEmergencyMessage = this.parsePromptMessage(this.afterHoursEmergencyMessage);

    message = this.customEmergencyMessage == null ? '' : this.customEmergencyMessage;
    this.customEmergencyMessage = message;

    //emergencyMessageText = (emergencyMessageType.value() == "Default") ? defaultEmergencyMessage : (emergencyMessageType.value() == "AfterHours") ? afterHoursEmergencyMessage : customEmergencyMessage;

    this.emergencyMessageText =
      this.selectedEmergencyMessageType.value == 'Default'
        ? this.defaultEmergencyMessage
        : this.selectedEmergencyMessageType.value == 'AfterHours'
          ? this.afterHoursEmergencyMessage
          : this.customEmergencyMessage;
    //eEmergencyMessageTypeChangeHandler();
  }
  parsePromptMessage(promptMessage) {
    let message = '';
    if (
      promptMessage != null &&
      (promptMessage.toLowerCase().indexOf('http://') == 0 || promptMessage.toLowerCase().indexOf('https://') == 0)
    ) {
      const audioFiles = [];
      const sb = promptMessage.toLowerCase().split(' ');
      for (var i in sb) {
        if (sb[i].indexOf('http://') == 0 || sb[i].indexOf('https://') == 0) audioFiles.push(sb[i]);
      }
      if (audioFiles.length == 0) {
        message = '';
      } else {
        message = 'Audio Files (' + audioFiles.length + ')';
        for (var i in audioFiles) {
          message += '\n' + audioFiles[i];
        }
      }
    } else {
      message = promptMessage == null ? '' : promptMessage;
    }
    return message;
  }

  modifyEmergencyMessageType(event: any) {
    const selectedMsgType = event.target.value;
    const lastMessageType = this.selectedEmergencyMessageType;

    if (lastMessageType.id != selectedMsgType) {
      if (selectedMsgType != 'Custom' && lastMessageType.id == 'Custom') {
        this.customEmergencyMessage = this.emergencyMessageText;
      }
      //lastMessageType = this.selectedEmergencyMessageType;

      for (const msgType of this.emergencyMessageType) {
        if (msgType.id == selectedMsgType) {
          this.selectedEmergencyMessageType = msgType;
        }
      }

      this.emergencyMessageText =
        selectedMsgType == 'Default'
          ? this.defaultEmergencyMessage
          : selectedMsgType == 'AfterHours'
            ? this.afterHoursEmergencyMessage
            : this.customEmergencyMessage;
    }
    //this.emergencyMessageText.enabled(this.selectedEmergencyMessageType == "Custom");
    //messageContainer.visible(emergencyMessageType.value() == "Custom");
    //previewBtn.enabled((emergencyMessageType.value() == "Custom" && $.trim(emergencyMessageText.value()) != '') || (emergencyMessageType.value() != "Custom"));

    /* if (initial) {
       lastMessageType = emergencyMessageType.value();
   }
   if (lastMessageType != emergencyMessageType.value()) {
       if (emergencyMessageType.value() != "Custom" && lastMessageType == "Custom")
           customEmergencyMessage = emergencyMessageText.value();
       lastMessageType = emergencyMessageType.value();
       emergencyMessageText.value((emergencyMessageType.value() == "Default") ? defaultEmergencyMessage : (emergencyMessageType.value() == "AfterHours") ? afterHoursEmergencyMessage : customEmergencyMessage);
   }
   emergencyMessageText.enabled(emergencyMessageType.value() == "Custom");
   messageContainer.visible(emergencyMessageType.value() == "Custom");
   previewBtn.enabled((emergencyMessageType.value() == "Custom" && $.trim(emergencyMessageText.value()) != '') || (emergencyMessageType.value() != "Custom"));
 t*/
  }

  loadQueueDetails(id: number) {
    this.managerService
      .GetQueueByID(id)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetQueueByID');
          if (isValid) {
            this.queueData = data.Response.Data;
            this.title = 'Queue ' + this.queueData.ID + ' - ' + this.queueData.Name;
            this.details = {
              ID: this.queueData.ID,
              owner: 'queue',
              object: 'agent',
              service: this.managerService,
              method: 'GetQueueAgents',
              priorities: false,
              persistence: false,
              roles: false,
              disable: !this.securityService.validateGrant('ManageAssignments'),
            };

            this.testingCheck = data.Response.Data.Testing;

            if (
              this.queueData.Type == 'Inbound' ||
              this.queueData.Type == 'TextChat' ||
              this.queueData.Type == 'VideoChat'
            ) {
              this.showAvailabilityContainer = true;
            } else {
              this.showAvailabilityContainer = false;
            }
            if (this.queueData.Type == 'Inbound') {
              this.showCallbackContainer = true;
            } else {
              this.showCallbackContainer = false;
            }

            this.queueID = this.queueData.ID;
            this.queueType =
              (this.queueData.DialerType == 'AutomatedInbound' ? 'Automated' : this.queueData.DialerType) +
              ' ' +
              this.queueData.Type;

            this.sunday = (this.queueData.ActiveDays & 1) == 1;
            this.monday = (this.queueData.ActiveDays & 2) == 2;
            this.tuesday = (this.queueData.ActiveDays & 4) == 4;
            this.wednesday = (this.queueData.ActiveDays & 8) == 8;
            this.thursday = (this.queueData.ActiveDays & 16) == 16;
            this.friday = (this.queueData.ActiveDays & 32) == 32;
            this.saturday = (this.queueData.ActiveDays & 64) == 64;

            this.startTime = this.convertToTime(this.queueData.StartTime);
            this.endTime = this.convertToTime(this.queueData.EndTime);
            let tz = '';
            if (this.queueData.TimeZone) {
              tz = this.queueData.TimeZone;
            } else {
              tz = 'Eastern Standard Time';
            }

            for (const timeZone of this.timezones) {
              //alert("test::"+JSON.stringify(timeZone))
              if (timeZone.value == tz) {
                this.timezoneSelect = timeZone;
              }
            }

            this.defaultEmergencyMessage = this.queueData.EmergencyDefaultMessage;
            this.customEmergencyMessage = this.queueData.EmergencyCustomMessage;
            this.afterHoursEmergencyMessage = this.queueData.EmergencyAfterHoursMessage;
            this.emergencyPromptID = this.queueData.EmergencyPromptID;
            this.afterHoursPromptID = this.queueData.AfterHoursPromptID;
            this.callBackByQueueLengthCheck = this.queueData.CallbackByQueueLength === true;
            this.callBackByWaitTimeCheck = this.queueData.CallbackByWaitTime === true;
            this.queueLengthMax = this.queueData.QueueLengthMax;
            this.waitTimeMax = this.queueData.WaitTimeMax;
            if (this.defaultEmergencyMessage != null)
              this.emergencyMessageType.push({
                value: 'Default',
                id: 'Default',
                msg: 'Use pre-defined default emergency message as configured by Onvida',
              });
            if (this.afterHoursEmergencyMessage != null)
              this.emergencyMessageType.push({
                value: 'After Hours',
                id: 'AfterHours',
                msg: 'Use pre-defined after hours message as configured by Onvida',
              });
            this.emergencyMessageType.push({
              value: 'Custom',
              id: 'Custom',
              msg: 'Use custom text-to-speech message',
            });
            const emergencymsgType =
              this.queueData.EmergencyMessageType == null || this.queueData.EmergencyMessageType == ''
                ? this.defaultEmergencyMessage != null
                  ? 'Default'
                  : 'Custom'
                : this.queueData.EmergencyMessageType;

            for (const msgType of this.emergencyMessageType) {
              if (msgType.id == emergencymsgType) {
                this.selectedEmergencyMessageType = msgType;
              }
            }
            this.emergencyCheck = this.queueData.EmergencyMode === true;
            this.emergencyBypassIVRCheck = this.queueData.EmergencyBypassIVR === true;

            this.setEmergencyMessage();
            /*toggleEmergencyFields(emergencyCheck.selected(), true);
          emergencyCheck.addEventListener(im.UIEvent.CHANGE, eEmergencyModeCheckHandler);
          emergencyBypassIVRCheck.addEventListener(im.UIEvent.CHANGE, eEmergencyBypassIVRCheckHandler);
          emergencyMessageText.addEventListener(im.UIEvent.CHANGE, eEmergencyMessageTypeChangeHandler);
          emergencyMessageType.addEventListener(im.UIEvent.CHANGE, eEmergencyMessageTypeChangeHandler);
  
          callbackByQueueLength.addEventListener(im.UIEvent.CHANGE, eCallBackCheckHandler);
          callbackByWaitTime.addEventListener(im.UIEvent.CHANGE, eCallBackCheckHandler);
  
          eCallBackCheckHandler();*/

            this.slaContainer = this.queueData.Type == 'Outbound';
            this.slaPreScheduleText = this.queueData.PreScheduleSLA || 0;
            this.slaPostScheduleText = this.queueData.PostScheduleSLA || 0;
            this.allowEarlyFollowUpsCheck = this.queueData.AllowEarlyFollowUps === true;
            /*
                  previewBtn.addEventListener(im.UIMouseEvent.CLICK, ePreviewBtnClickHandler);*/
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
  fileUpload(res) {
    //alert(JSON.stringify(res))
    let currValue = this.emergencyMessageText;
    currValue += currValue == null || currValue.trim() == '' ? '' : '\n';
    this.emergencyMessageText = currValue + res.message;
    this.eEmergencyMessageTypeChangeHandler();
  }

  eEmergencyMessageTypeChangeHandler() {
    /*  if (initial) {
        lastMessageType = emergencyMessageType.value();
      }
      if (lastMessageType != emergencyMessageType.value()) {
        if (emergencyMessageType.value() != "Custom" && lastMessageType == "Custom")
          customEmergencyMessage = emergencyMessageText.value();
        lastMessageType = emergencyMessageType.value();
        emergencyMessageText.value((emergencyMessageType.value() == "Default") ? defaultEmergencyMessage : (emergencyMessageType.value() == "AfterHours") ? afterHoursEmergencyMessage : customEmergencyMessage);
      }
      emergencyMessageText.enabled(emergencyMessageType.value() == "Custom");
      messageContainer.visible(emergencyMessageType.value() == "Custom");
  */
  }

  async loadTimeZones() {
    const data: any = await lastValueFrom(this.managerService.GetTimeZones());
    const isValid = ResponseHandler.processResponse(data, 'GetTimeZones');
    if (isValid) {
      for (let x = 0, y = data.Response.Data.length; x < y; x++) {
        this.timezones.push({
          label: data.Response.Data[x].Name,
          value: data.Response.Data[x].ID,
        });
      }
    }
  }
  convertToTime(toConvert) {
    const hours = Math.floor(toConvert / 100);
    const minutes = toConvert - hours * 100;
    const time = new Date();
    time.setHours(hours);
    time.setMinutes(minutes);
    return time;
  }

  convertFromTime(toConvert: Date) {
    const hour = toConvert.getHours();
    const minutes = toConvert.getMinutes();
    const converted = minutes + hour * 100;
    return converted;
  }

  saveChanges() {
    const assignedAgents = this.assignAgentComponent.assignedDisplay;
    const agents = [];
    //let assignedAgents = this.assignAgentComponent.assignedAgents.filter((agent:any)=>  agent.Assigned).map((ag)=>ag.ID.toString());

    for (const group of assignedAgents) {
      for (const agent of group.options) {
        agents.push(agent.value);
      }
    }

    const data = {
      id: this.queueID,
      agents: agents,
      testing: this.testingCheck,
      //outboundStopped: outboundStopCheck.selected(),
      outboundStopped: false,
      emergencyMode: this.emergencyCheck,
      emergencyBypassIVR: this.emergencyBypassIVRCheck,
      emergencyMessage: this.emergencyMessageText.trim(),
      emergencyMessageType: this.selectedEmergencyMessageType.id,
      activeDays: 0,
      startTime: this.convertFromTime(this.startTime),
      endTime: this.convertFromTime(this.endTime),
      timezone: this.timezoneSelect.value,
      preScheduleSLA: this.slaPreScheduleText,
      postScheduleSLA: this.slaPostScheduleText,
      allowEarlyFollowUps: this.allowEarlyFollowUpsCheck,
      callbackByQueueLength: this.callBackByQueueLengthCheck,
      callbackByWaitTime: this.callBackByWaitTimeCheck,
      queueLengthMax: this.queueLengthMax,
      waitTimeMax: this.waitTimeMax,
    };

    // this.sunday = ((this.queueData.ActiveDays & 1) == 1);
    // this.monday = ((this.queueData.ActiveDays & 2) == 2);
    // this.tuesday = ((this.queueData.ActiveDays & 4) == 4);
    // this.wednesday = ((this.queueData.ActiveDays & 8) == 8);
    // this.thursday = ((this.queueData.ActiveDays & 16) == 16);
    // this.friday = ((this.queueData.ActiveDays & 32) == 32);
    // this.saturday = ((this.queueData.ActiveDays & 64) == 64);

    if (this.sunday) data.activeDays += 1;
    if (this.monday) data.activeDays += 2;
    if (this.tuesday) data.activeDays += 4;
    if (this.wednesday) data.activeDays += 8;
    if (this.thursday) data.activeDays += 16;
    if (this.friday) data.activeDays += 32;
    if (this.saturday) data.activeDays += 64;

    this.managerService
      .EditQueueDetails(data)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'EditQueueDetails');
          if (isValid) {
            this.location.back();
          }
        })
      )
      .subscribe();
  }
  goBack() {
    this.location.back();
  }
}
